/* eslint-disable no-unused-vars */
/*
 * @Author: Jiajia Li
 * @Modified By: Jesse Chalker
 * @Date: 2024-08-11 20:51:54
 * @LastEditTime: 2025-04-11 14:29:30
 * @Description:
 */
// import React from "react";
// import { useEffect, useState, useCallback } from "react";
// import { useLocation } from "react-router-dom";
// import SessionExpiredModal from "./components/SessionExpiredModal";
// import { attachSessionListeners, clearSessionExpiredFlag } from "./utils/sessionBus";
// import { startTokenWatcher, stopTokenWatcher } from "./utils/tokenWatcher";
import GlobalSessionUI from "./components/GlobalSessionUI";
import {
  RouterProvider,
  createRoutesFromElements,
  createBrowserRouter,
  Route,
} from "react-router-dom";
import { Helmet } from 'react-helmet-async'
import User from "./components/User";
import Login from "./components/Login";
import About from "./components/About";
import SkinType from "./skinquiz/SkinType";
import SkinConcerns from "./skinquiz/SkinConcerns";
import SkinSensitivity from "./skinquiz/SkinSensitivity";
import SelectSkinTone from "./skinquiz/SelectSkinTone";
import SelectUnderTone from "./skinquiz/SelectUnderTone";
import FindUnderTone from "./skinquiz/FindUnderTone";
// eslint-disable-next-line no-unused-vars
import HomePage, { loader } from "./homepage/HomePage";
import UploadPhoto from "./components/UploadPhoto";
import Products from "./homepage/Products";
import Profile from "./components/Profile";
import Type2QuestionsPage from "./skinquiz/Type2QuestionsPage";
import FindSkinSensitivity from "./skinquiz/FindSkinSensitivity";
import { CuruProvider } from "./context/CuruContext";
import ProductSearch from "./pages/ProductSearch";
import ErrorPage from "./pages/ErrorPage";
import ProductDetailsPage from "./pages/ProductDetailsPage";

import ReviewPage from "./pages/ReviewPage";
import PostsPage from "./pages/PostsPage";
import Wishlist from "./pages/WishList";
import EditProfile from "./components/EditProfile";

import Root from "./components/Root";
import CategoryProducts from "./pages/CategoryProducts";
import BrandProducts, { BrandProductLoader } from "./pages/BrandProducts";
import ProductListWrapper from "./components/ProductListWrapper";
import "bootstrap/dist/css/bootstrap.min.css";
import CuruChatsPage from "./pages/CuruChatsPage";
import CuruChatsCategory from "./pages/CuruChatsCategory";
import OtherUserProfile from "./components/OtherUserProfile";
import { XPProvider } from "./context/XPContext";
import { FilterProvider } from "./context/FilterContext";
import FeedbackPage from "./pages/FeedbackPage";

const router = createBrowserRouter(
  createRoutesFromElements(
   <Route element={<GlobalSessionUI />} errorElement={<ErrorPage />}>
      <Route path="/" element={<Login />} />
      <Route path="/about" element={<About />} />
      <Route path="/user" element={<User />} />
      <Route path="/UploadPhoto" element={<UploadPhoto />} />
      <Route path="/skin-type" element={<SkinType />} />
      <Route path="/type2-questions" element={<Type2QuestionsPage />} />
      <Route path="/skin-concerns" element={<SkinConcerns />} />
      <Route path="/skin-sensitivity" element={<SkinSensitivity />} />
      <Route path="/select-skintone" element={<SelectSkinTone />} />
      <Route path="/select-undertone" element={<SelectUnderTone />} />
      <Route path="/find-undertone" element={<FindUnderTone />} />
      <Route path="/find-skin-sensitivity" element={<FindSkinSensitivity />} />
      <Route path="/edit-profile" element={<EditProfile />} />

      <Route element={<Root />}>
        <Route path="/home-page" element={<HomePage />} />
        <Route path="/browse-products" element={<Products />} />
        <Route path="/user-profile" element={<Profile />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route
          path="/recommended-products"
          element={<ProductListWrapper title="Recommended for you" />}
        />
        <Route path="/search" element={<ProductSearch />}></Route>
        <Route path="/products" element={<CategoryProducts />}>
          <Route path="category">
            <Route path=":categoryId" element={<CategoryProducts />}>
              <Route path=":subCategoryId" element={<CategoryProducts />}>
                <Route path=":subHeadingId" element={<CategoryProducts />} />
              </Route>
            </Route>
          </Route>
        </Route>
        <Route
          path="brand/:brand"
          loader={BrandProductLoader}
          element={<BrandProducts />}
        ></Route>
        <Route path="/product-details/:id" element={<ProductDetailsPage />} />
        <Route path="/product/:id/reviews" element={<ReviewPage />} />
        <Route path="/product/:id/posts" element={<PostsPage />} />
        <Route path="/curu-chats" element={<CuruChatsPage />} />
        <Route
          path="/curu-chats/category/:categoryId"
          element={<CuruChatsCategory />}
        />
        <Route path="/profile/:id" element={<OtherUserProfile />} />
      </Route>
    </Route>
  )
);

export default function App() {
  return (
    <>
      <helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap"
          rel="stylesheet"
        ></link>
      </helmet>
      <XPProvider>
        <FilterProvider>
          <CuruProvider>
            <RouterProvider router={router} />
          </CuruProvider>
        </FilterProvider>
      </XPProvider>
    </>
  );
}
